import * as React from 'react'
import { UserInviteListConnected } from './UserInviteListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UserInviteListExamples = () => {
  return (
    <div className="UserInviteListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UserInviteListConnected />
      </Provider>
    </div>
  )
}
